/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */

import React from "react";
import { useNavigate } from "react-router-dom";

import {
  GenericImageComponent,
  GenericImageConfig,
} from "../GenericImageComponent/GenericImageComponent";
import "./TextBubble.css";

/* eslint-disable react/no-unused-prop-types */
export interface TextBubbleConfig {
  kind: "TextBubbleConfig";
  textBubbleText: string;
  authorUserHandle: string;
  authorProfilePic: GenericImageConfig;
}
/* eslint-enable react/no-unused-prop-types */

export const textBubbleConfigDemo1: TextBubbleConfig = {
  kind: "TextBubbleConfig",
  textBubbleText:
    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas, Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas, Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas, Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas",
  authorUserHandle: "ulidabess",
  authorProfilePic: {
    kind: "CloudinaryImageConfig",
    publicId: "ProfilePictures/default",
  },
};

export function TextBubble(props: TextBubbleConfig): JSX.Element {
  const { textBubbleText, authorProfilePic } = props;
  const navigate = useNavigate();
  const navigateToAuthorProfile = () => navigate(`/@${props.authorUserHandle}`);
  return (
    <div className="text-bubble-wrapper">
      <div className="text-bubble-text-itself">{textBubbleText}</div>

      <button
        type="button"
        className="text-bubble-profile-pic-button"
        onClick={navigateToAuthorProfile}
      >
        {GenericImageComponent(authorProfilePic)}
      </button>
    </div>
  );
}
